import { render } from "./StepBarThatContainsStatus.vue?vue&type=template&id=044d98d4"
import script from "./StepBarThatContainsStatus.vue?vue&type=script&lang=js"
export * from "./StepBarThatContainsStatus.vue?vue&type=script&lang=js"
script.render = render

export default script